import React from 'react';
import './LCPcontent.css';


const LCPcontent = () => {
    return (
        <div className="LCP-container">
            <div className="Page-Main_Dec">
                <h1 className="Page-title_LowerCase">Light Control & Privacy</h1>
            </div>


            <div className="LCP-section">
                <div className="LCP-image">
                    <img src="/Assets/LCPimages/colby-solution.webp" />
                </div>
                <div className="LCP-text">
                    <h4>Day and Night – Colby solution</h4>
                    <p>Callistus Day & Night Colby Blinds are the unique combination of two types of fabrics that facilitates different light control modes. One can bring the top to bottom or bottom to top and also stop the two combinations in any position to get the desired Light into the room.</p>
                </div>
            </div>

            <div className="LCP-section">
                <div className="LCP-image">
                    <img src="/Assets/LCPimages/TDBU-3.webp" />
                </div>
                <div className="LCP-text">
                    <h4>Top down bottom up – operation to control privacy and enjoy the environment</h4>
                    <p>Callistus TDBU Colby Blinds are the most innovative blinds in which not only it can be moved from bottom to top but also from top to bottom or stop in between to get the convenient mode of light and privacy.</p>
                </div>
            </div>


            <div className="LCP-section">
                <div className="LCP-image">
                    <img src="/Assets/LCPimages/grayson-blinds.webp" />

                </div>
                <div className="LCP-text">
                    <h4>Venetian type light diffusing feature - Grayson Blinds</h4>
                    <p>Callistus Grayson blinds have the light diffusing characteristics which creates beautiful gradation of soft romantic light into the room. It has special combination of two sheer fabrics with tilting vanes in between to adjust light in the entire area of the blinds.</p>
                </div>
            </div>

            <div className="LCP-section">
                <div className="LCP-image">
                    <img src="/Assets/LCPimages/conversion.webp" />
                </div>
                <div className="LCP-text">
                    <h4>Same Fabric Conversion option for Roman Blinds</h4>
                    <p>For the first time Callistus Roman Blinds offers unique fabric conversion option. One can convert visible fabric to Translucent or Blackout, and Translucent fabric to Blackout by using lining fabric. So now, one has an option to utilize the same fabric in multiple ways at various locations to control Light, Privacy and Heat as per the mood and need.</p>
                </div>
            </div>

            <div className="LCP-section">
                <div className="LCP-image">
                    <img src="/Assets/LCPimages/sunscreen.webp" />
                </div>
                <div className="LCP-text">
                    <h4>Sunscreen /Translucent / Blackout shades</h4>
                    <p>Callistus Blinds have option of three types of Fabric as per the desired privacy, need and mood – Sunscreen, Translucent or Blackout.</p>
                </div>
            </div>

            <div className="LCP-section">
                <div className="LCP-image">
                    <img src="/Assets/LCPimages/big-sunscreen.webp" />
                </div>
                <div className="LCP-text">
                    <h4>Opacity – Openness in Fabrics</h4>
                    <p>Callistus window Fashion produces fabric with various levels of Openness factor.  Our Openness factor has options from 1 to 15% and a customer can opt the type of fabric based on the need</p>
                </div>
            </div>

            <div className="LCP-section">
                <div className="LCP-image">
                    <img src="/Assets/LCPimages/luzon-blinds.webp" />
                </div>
                <div className="LCP-text">
                    <h4>Luzon Blinds</h4>
                    <p>Callistus Luzon blinds provides the luxury to control and adjust light in the entire area of the blinds with a swift single touch in various percentages creating beautiful 3D effect. By sliding two fabrics which are the combination of Sheer and Dim-out one can enjoy the view outside by enjoying privacy.</p>
                </div>
            </div>

            <div className="LCP-section">
                <div className="LCP-image">
                    <img src="/Assets/LCPimages/8.webp" />
                </div>
                <div className="LCP-text">
                    <h4>Meliso Blinds</h4>
                    <p>Callistus Meliso Blinds creates beautiful folds and light diffusion in entire area of the blinds. This type of Blinds forms aesthetic pleats when closing and helps to contemplate a softened outside view through the sheer backing. With a gentle pull of operating cord the light can be adjusted or also can be motorized for easier operation.</p>
                </div>
            </div>

            <div className="LCP-section">
                <div className="LCP-image">
                    <img src="/Assets/LCPimages/sierra-blinds.webp" />
                </div>
                <div className="LCP-text">
                    <h4>Sierra Blinds</h4>
                    <p>Callistus Sierra blinds gives the feeling of curtain with the benefit of blinds, having beautiful light control facility in it. By tilting the vertical vanes light can be adjusted 180 degrees and the whole blinds can be customized to left or right stacking or centre split to follow desired sunlight</p>
                </div>
            </div>

        </div>
    );
};

export default LCPcontent;
